import { RoutingProvider } from '@tbitop/routing';
import type { PropsWithChildren } from 'react';
import { useMobileRouting } from './mobile-routing';

export const MobileRoutingProvider = (props: PropsWithChildren<unknown>) => {
  const routing = useMobileRouting();
  return (
    <RoutingProvider routing={routing} {...props} />
  );
};
